import ProtectedLayout from "layouts/Protected"
import React, { useMemo } from "react"
import { isMobileOnly } from "react-device-detect"
import clsx from "clsx"

import HeaderBikeLabelOrder from "./HeaderBikeLabelOrder"
import BikeLabelOrderVisualStep from "./bikeLabelOrderStep/BikeLabelOrderVisualStep"
import { useGetStepQueryParams } from "../hooks/useGetStepQueryParams"
import { getStep } from "../utils"
import { useTranslation, Trans } from "react-i18next"
import { useAppSelector } from "store/hooks"
import { CheckOutStateEnum } from "store/type"
import { Link } from "react-router-dom"
import { privateRoutes } from "router/routes"

type BikeLabelOrderLayoutProps = {
	children: React.ReactElement | React.ReactElement[]
}

const BikeLabelOrderLayout: React.FC<BikeLabelOrderLayoutProps> = ({ children }) => {
	const step = useGetStepQueryParams()
	const { t } = useTranslation()
	const currentStep = getStep(step)
	const orderCustomID = useAppSelector((state) => state.bikeLabelOrder.orderCustomID)
	const checkOutStateProduct = useAppSelector(
		(state) => state.bikeLabelOrder.checkOutStateProduct
	)
	const isLoading = useMemo(
		() => checkOutStateProduct === CheckOutStateEnum.LOADING,
		[checkOutStateProduct]
	)

	const isError = useMemo(
		() => checkOutStateProduct === CheckOutStateEnum.ERROR,
		[checkOutStateProduct]
	)

	return (
		<ProtectedLayout className={"py-5 min-h-screen"}>
			<div className="l-container">
				<HeaderBikeLabelOrder />
				{isLoading ? (
					<div className="w-full flex justify-center items-center">
						<div className="c-spinner"></div>
					</div>
				) : isError ? (
					<div className="w-full h-full flex justify-center ">
						<div className="c-card p-5 md:p-12 mt-4 w-[calc(100%-3rem)] gap-6 flex flex-col">
							<div className="font-[jost] c-h2 font-semibold uppercase">
								{t("title.noCommand", { ns: "label" })}
							</div>
							<div className="text-neutral-900">
								{t("errorPage.sentence1", { ns: "label" })}
							</div>
							<div className="text-neutral-900">
								<Trans ns="label" i18nKey="errorPage.sentence2">
									Pour plus d’informations, veuillez contacter
									<Link to={privateRoutes.contact.path} className="underline">
										votre équipe support BicyCode
									</Link>
									.
								</Trans>
							</div>
						</div>
					</div>
				) : (
					<div
						className={clsx("max-w-full", {
							"px-8": !isMobileOnly,
							"px-6": isMobileOnly,
						})}
					>
						<BikeLabelOrderVisualStep />
						<div className="c-card p-5 md:p-12 mt-4">
							<div className="  c-h2 text-[1.60rem] uppercase">
								{currentStep
									? t(currentStep?.title, {
											step: step,
											ns: "label",
											code: orderCustomID,
										})
									: null}
							</div>
							{children}
						</div>
					</div>
				)}
			</div>
		</ProtectedLayout>
	)
}
export default BikeLabelOrderLayout
